export const matterTypes = [
    {
        matterType: "10",
        description: "Andre sager",
        isDebtCollectionMatter: false,
        isRealEstateMatter: false,
        isBankruptcyMatter: false,
        isEstateOfTheDeceasedMatter: false,
        isDebtReliefMatter: false,
        isCorporationMatter: false,
        hasStakeholderAccess: false,
        hasStakeholderAccessToDocuments: false,
        encryptDocuments: false,
        isNotInUse: false,
        isMainGroup: false,
        isCrmMatter: false,
        isSatisfactorySurveyMatter: false,
        excludeAntiMoneyLaundering: false,
        isAutoCourt: false,
        hasEmployeeMatterTypeAccess: false
    }
];
